import React, { useEffect, useState } from 'react';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import DeleteIcon from '@mui/icons-material/Delete';
import { EOIGet } from '../../../Store/auth/register';
import { useQuery } from '@tanstack/react-query';

const FinancialYearForm = ({ onFinancialYearsChange }) => {
  // State to hold the financial year rows
  const [financialYears, setFinancialYears] = useState([
    { financial_year: '', yes_no: '' },
  ]);

  const gsnNoFromStorage = localStorage.getItem('gsn_no');


  const { data: questions } = useQuery({
    queryKey: 'EOI',
    queryFn: () => EOIGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
    });

    const [touched, setTouched] = useState([false]);


    useEffect(() => {
        if (questions?.documents?.audited_accounts) {
          setFinancialYears(questions.documents.audited_accounts);
          setTouched(Array(questions.documents.audited_accounts.length).fill(false));
        }
      }, [questions]);
    

  useEffect(() => {
    onFinancialYearsChange(financialYears);
  }, [financialYears, onFinancialYearsChange]);

  const handleBlur = (index) => {
    const updatedTouched = [...touched];
    updatedTouched[index] = true;
    setTouched(updatedTouched);
  };

  // Handle input changes for both financial year and Yes/No fields
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    // Make a copy of the financialYears array to ensure immutability
    const updatedFinancialYears = [...financialYears];
    updatedFinancialYears[index][name] = value;

    // Update the state with the modified array
    setFinancialYears(updatedFinancialYears);
  };
  
  const currentYear = new Date().getFullYear(); // Get the current year

  const option1 = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => {
    const startYear = 2000 + i;
    const endYear = startYear + 1;
    return { option: `${startYear}-${endYear.toString().slice(-2)}` };
  });

  // Add a new row
  const addRow = () => {
    setFinancialYears([...financialYears, { financial_year: '', yes_no: '' }])
    setTouched([...touched, false]);
  };

  // Remove a row
  const removeRow = (index) => {
    const updatedFinancialYears = [...financialYears];
    const updatedTouched = [...touched];
    updatedFinancialYears.splice(index, 1);
    updatedTouched.splice(index, 1);
    setFinancialYears(updatedFinancialYears);
    setTouched(updatedTouched);
  };


  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // 
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="w-full p-4 border-2 rounded-t-xl flex items-center justify-between">
        <div>
          <h3 className="text-2xl text-black p-0 m-0">Audited Accounts</h3>
          <h3 className="text-base text-black p-0 m-0 mt-1">You need to provide financials for the latest 3 years for Certification.</h3>
        </div>
        <div className="flex gap-5">
          { (
            <button
              type="button"
              onClick={addRow}
              className="px-6 h-10 text-white bg-[#004878] rounded-full py-2"
            >
              Add Row
            </button>
          )}
        </div>
      </div>

      <div className="scrollbar-thin w-full overflow-x-auto">
        <table className="border-2 text-[#667085] rounded-t-2xl w-full">
          <thead>
            <tr className="border-b-2">
              <th className="p-3">No.</th>
              <th className="p-3 min-w-[150px]">Financial Year</th>
              <th className="p-3 min-w-[100px]">Yes/No</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {financialYears.map((row, index) => (
              <tr key={index} className="border-b-2">
                <td className="p-3">{index + 1}</td>
                
                <td className="p-3">
                  <CustomSelection
                    name="financial_year" // Use new field name
                    value={row.financial_year}  
                    onChange={(e) => handleInputChange(index, e)} // Update state on change
                    options={option1}
                    className="border px-2 py-1 w-full"
                    label="financialYear"
                  />
                  {touched[index] && row.financial_year === '' && (
                    <span className="text-red-500 text-sm">Required</span>
                  )}
                </td>
                <td className="p-3">
                  <CustomSelection
                    name="yes_no" // Use new field name
                    value={row.yes_no}  // Pass the value from state
                    onChange={(e) => handleInputChange(index, e)} // Update state on change
                    options={[
                      { option: 'Yes', value: 'Yes' },
                      { option: 'No', value: 'No' },
                    ]}
                    className="border px-2 py-1 w-full"
                    label="Yes/No"
                    noSort={true}
                  />
                  {touched[index] && row.yes_no === '' && (
                    <span className="text-red-500 text-sm">Required</span>
                  )}
                </td>
                <td className="p-3">
                  <button
                    type="button"
                    onClick={() => removeRow(index)}
                    className=" px-4 py-2 rounded-full"
                  >
                    <DeleteIcon/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
    </form>
  );
};

export default FinancialYearForm;
